export default "__VITE_ASSET__C9NL6aVl__"